import { render, staticRenderFns } from "./Resident.vue?vue&type=template&id=74ca6d94"
import script from "./Resident.vue?vue&type=script&lang=js"
export * from "./Resident.vue?vue&type=script&lang=js"
import style0 from "./Resident.vue?vue&type=style&index=0&id=74ca6d94&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports